import { render, staticRenderFns } from "./ContactInformationProfileActions.vue?vue&type=template&id=296962a5&scoped=true&"
import script from "./ContactInformationProfileActions.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationProfileActions.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationProfileActions.vue?vue&type=style&index=0&id=296962a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296962a5",
  null
  
)

export default component.exports